import keys from '@debbie/common/dist/cache/keys.js'
import * as _collectors from '@debbie/common/dist/collectors/index.js'
import { Plan } from '@debbie/common/dist/economy/payment-plans/index.js'
import { Currency } from '@debbie/common/dist/index.js'
import { useMutation } from '@debbie/common/dist/util/hooks.js'
import { deleteCard } from '@debbie/cortex/dist/api/payment-plans.js'
import { paymentPlansEntity } from '@debbie/cortex/dist/paymentPlans/index.js'
import q from '@debbie/cortex/dist/query.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Button, Panel } from '@debbie/iris/dist/components/index.js'
import { errorNotification } from '@debbie/iris/dist/utils/errors.js'
import React from 'react'
import { useSelector } from 'react-redux'

import EntriesList from './EntriesList.js'

type Props = { currency: Currency; caseId: string; paymentPlan: Plan }

const CongratulationsStep = ({ currency, caseId, paymentPlan }: Props) => {
  const lang = useSelector((s: RootState) => s.lang)

  const removeCard = useMutation(() => deleteCard(paymentPlan.paymentPlanId), {
    onSuccess: () =>
      q.invalidate(
        keys.write.modify(paymentPlansEntity, paymentPlan.paymentPlanId),
      ),
    onError: (err) =>
      errorNotification(lang, err, 'update', lang.errorEntities.paymentPlan),
  })

  return (
    <div>
      <Panel header={lang.debtorWebPaymentPlans.approval}>
        <p>{lang.debtorWebPaymentPlans.approvalText}</p>
      </Panel>
      <Panel>
        <p>{lang.debtorWebPaymentPlans.deleteCardToChange}</p>
        <Button
          loading={removeCard.isLoading}
          onClick={() => removeCard.mutate()}
        >
          {lang.debtorWebPaymentPlans.deleteCard}
        </Button>
      </Panel>
      <Panel>
        <EntriesList paymentPlan={paymentPlan} currency={currency} />
      </Panel>
    </div>
  )
}

export default CongratulationsStep
